import { initialFilter } from "app/modules/schedule/ScheduleUIHelpers";
import { createContext, useContext, useEffect, useState } from "react";
// REDUX
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { getListSchedule } from "../../redux/schedule";

const HomeUIContext = createContext();

export const useHomeUIContext = () => {
  return useContext(HomeUIContext);
};

export const HomeUIConsumer = HomeUIContext.Consumer;

export function HomeUIProvider({ children }) {
  const dispatch = useDispatch();
  const [signUpData, setSignUpData] = useState({});

  const { getListScheduleData } = useSelector(
    (state) => ({
      getListScheduleData: state.GetListScheduleData,
    }),
    shallowEqual
  );
  const { data, isLoading } = getListScheduleData;

  useEffect(() => {
    dispatch(getListSchedule(initialFilter));
  }, [dispatch]);

  const dataUIEvents = {};

  const value = {
    data,
    isLoadingData: isLoading,
    signUpData,
    setSignUpData,
    goToSignUp: dataUIEvents.goToSignUp,
  };

  return (
    <HomeUIContext.Provider value={value}>{children}</HomeUIContext.Provider>
  );
}
